import { render, staticRenderFns } from "./GroupBy.vue?vue&type=template&id=1af442a1&"
import script from "./GroupBy.vue?vue&type=script&lang=ts&"
export * from "./GroupBy.vue?vue&type=script&lang=ts&"
import style0 from "./GroupBy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af442a1')) {
      api.createRecord('1af442a1', component.options)
    } else {
      api.reload('1af442a1', component.options)
    }
    module.hot.accept("./GroupBy.vue?vue&type=template&id=1af442a1&", function () {
      api.rerender('1af442a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/groupby/GroupBy.vue"
export default component.exports